import React from 'react';
import { FadeIn } from './ui/FadeIn';
const partners = ['Developers', 'Estate Surveyors', 'Property Firms', 'Corporate Relocation Teams'];
export function Partnership() {
  return <section id="partners" className="py-32 bg-zinc-950 border-t border-white/5" data-id="element-168">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-5xl font-display font-medium text-white leading-tight mb-12" data-id="element-171">
            "MUNISVerse operates as a virtual inspection and presentation
            partner, not a replacement for estate firms."
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-172">
          <p className="text-zinc-500 uppercase tracking-widest text-sm mb-8" data-id="element-173">
            We collaborate seamlessly with
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-6" data-id="element-174">
            {partners.map((partner, index) => <span key={index} className="text-xl md:text-2xl font-display text-zinc-400" data-id="element-175">
                {partner}
              </span>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}